"use strict";
/* istanbul ignore file */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CACHE_STATUS_FRESH = exports.CACHE_STATUS_EXPIRED = exports.RECONNECTION_RETRY_TIME = void 0;
const RECONNECTION_RETRY_DURATION_IN_MINUTES = process.env.RECONNECTION_RETRY_TIME_IN_MINUTES
    ? parseInt(process.env.RECONNECTION_RETRY_TIME_IN_MINUTES)
    : 3;
exports.RECONNECTION_RETRY_TIME = RECONNECTION_RETRY_DURATION_IN_MINUTES * 60 * 1000;
exports.CACHE_STATUS_EXPIRED = 'expired';
exports.CACHE_STATUS_FRESH = 'fresh';
